module.exports = __webpack_public_path__ + "media/images/icons/twotone/sliders-8725788423407a3c3b4df9a7cb9fc025.svg";